module.exports = __webpack_public_path__ + "img/icon-account-invoice-green@3x.cc63f0e4.png";